
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import MentorDetailsDialog from "./MentorDetailsDialog";
import MentorsListCard from "./MentorsListCard";
import { useMentorApplications } from "./useMentorApplications";
import { MentorApplication } from "./MentorTypes";

const AdminMentors: React.FC = () => {
  const { 
    applications, 
    loading, 
    fetchMentorApplications, 
    updateApplicationStatus 
  } = useMentorApplications();
  
  const [selectedMentor, setSelectedMentor] = useState<MentorApplication | null>(null);
  const [detailsOpen, setDetailsOpen] = useState(false);
  
  useEffect(() => {
    fetchMentorApplications();
  }, []);
  
  const handleViewDetails = (mentor: MentorApplication) => {
    setSelectedMentor(mentor);
    setDetailsOpen(true);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Mentors</h2>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={fetchMentorApplications} 
          disabled={loading}
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${loading ? "animate-spin" : ""}`} />
          Refresh
        </Button>
      </div>
      
      <MentorsListCard 
        applications={applications}
        loading={loading}
        onViewDetails={handleViewDetails}
        onUpdateStatus={updateApplicationStatus}
      />
      
      <MentorDetailsDialog
        open={detailsOpen}
        onOpenChange={setDetailsOpen}
        mentor={selectedMentor}
        onUpdateStatus={updateApplicationStatus}
      />
    </div>
  );
};

export default AdminMentors;
